<template>
  <ul class="pagination" v-if="paginator.totalPages > 1 && paginator.pages.length > 0">
    <!-- Prev Arrow -->
    <li v-if="paginator.prevPage"><a href="" @click.prevent="gotoPage(paginator.prevPage)" title="" aria-label=""><i
      class="icon-arrow-right prev"></i></a></li>
    <!-- Numbers -->
    <template v-for="page in paginator.pages">
      <li v-if="page.show">
        <a href="" v-if="page.page !== '...'" @click.prevent="gotoPage(page.page)" :title="page.page" aria-lable=""
          :class="{ active: page.page === paginator.currentPage }"><span>{{ page.page }}</span></a>
        <span v-else>{{ page.page }}</span>
      </li>
    </template>
    <!-- Next Arrow -->
    <li v-if="paginator.nextPage"><a href="" @click.prevent="gotoPage(paginator.nextPage)" title="" aria-label=""><i
      class="icon-arrow-right next"></i></a></li>
  </ul>
</template>

<script>
export default {
  name: "paginator",
  props: ['totalRecords', 'startRecord', 'endRecord', 'perPage', 'limitPageLinksTo'],
  computed: {
    paginator: function () {

      let perPage = this.perPage;
      let totalPages = Math.ceil(this.totalRecords / perPage);
      let currentPage = Math.ceil((this.startRecord - 1) / perPage) + 1;

      let limitPageLinksTo = 8;
      if (this.limitPageLinksTo) {
        limitPageLinksTo = this.limitPageLinksTo;
      }

      let nextPage = null;
      if (currentPage < totalPages) {
        nextPage = currentPage + 1;
      }

      let prevPage = null;
      if (currentPage > 1) {
        prevPage = currentPage - 1;
      }


      const range = (start, end, length = end - start + 1) =>
        Array.from({length}, (_, i) => start + i);

      let pages = collect(range(1, totalPages)).transform((item) => {

        let end = item * perPage;
        let start = end - perPage;
        let show = true;
        let page = item;

        // If the list of pages is crazy long, then truncate to eight page links with ... before
        // the last one. If we are at the end, then show the last eight without the ...

        let offset = currentPage + limitPageLinksTo; // we need to scroll forward the pages if we go past the link limit.

        if (totalPages > limitPageLinksTo) {
          if (page > offset) {
            show = false;
          }

          if (page < (offset - limitPageLinksTo)) {
            show = false;
          }

          let withinLastPages = (currentPage > (totalPages - limitPageLinksTo) && (page > (totalPages - limitPageLinksTo)));

          if (withinLastPages) {
            show = true;
          }

          // If the page is the second to last page, then show some dots.
          if (item === totalPages - 1) {
            show = true;
            if (!withinLastPages) {
              page = '...'
            }
          }

          // If the page is the last page
          if (item === totalPages) {
            show = true;
          }
        }

        return {
          page: page,
          show: show,
          start: start,
          end: end
        }
      }).all();

      return {
        currentPage: currentPage,
        prevPage: prevPage,
        nextPage: nextPage,
        totalPages: totalPages,
        pages: pages
      }
    }
  },
  methods: {
    gotoPage(page) {
      let gotoPage = collect(this.paginator.pages).where('page', page).first();
      this.$emit('gotoPage', gotoPage)
    },
  }
}
</script>

<style scoped>

</style>
